import classNames from 'classnames';

import Typography from '../typography/typography';

export interface PageTitleProps {
  className?: string;
  primary?: React.ReactNode;
  secondary?: React.ReactNode;
  tertiary?: React.ReactNode;
}

/**
 * Title component which can be used for the headline of each page
 */
export function PageTitle(props: PageTitleProps) {
  const { className } = props;
  return (
    <div className={classNames(className, 'flex flex-col capitalize')}>
      {props.secondary && (
        <Typography variant="none" variantFontSize="h3" className="text-zinc-200">
          {props.secondary}{' '}
        </Typography>
      )}
      {props.primary && (
        <Typography variant="none" className="py-1 text-3xl font-semibold">
          {props.primary}
        </Typography>
      )}
      {props.tertiary && <p className="font-regular text-sm tracking-normal text-zinc-100">{props.tertiary}</p>}
    </div>
  );
}

export default PageTitle;
